export default __webpack_public_path__ + "static/media/dataweb.ce38b1a2.jpg";